import script from "./ChatModule.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatModule.vue?vue&type=script&setup=true&lang=js"

import "./ChatModule.vue?vue&type=style&index=0&id=354570b8&lang=scss"

const __exports__ = script;

export default __exports__